import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as option from "@/models/configurator/configurator_options";

import { FrameState } from "./types";

const state: FrameState = {
  finish: null,
  finial: null,
  finialFinish: undefined,
  bottomPole: null,
  spigot: null,
  altaPagoda: false
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
